import React from "react";
import { Navigate } from "react-router-dom";
import { useUiPack } from "@/hooks/useUiPack";
import SimpleMastersHub from "@/pages/simple/SimpleMastersHub";

/** Simple pack: masters hub. Classic: send to product list (previous default). */
export default function UiPackMastersHub() {
  const { isSimple } = useUiPack();
  if (!isSimple) return <Navigate to="/masters/menu-item/list" replace />;
  return <SimpleMastersHub />;
}
